var TextWithLogo = {
	init:function(){
		$("[TextWithLogo]").each(function(){
			
			var _img = $(".logo-animated").html();
			var _txt = $(this).html().split("Mila");
			var _txt_formated = [];
			
			for(var i = 0; i < _txt.length; i++){
				_txt_formated.push("<span class='txt'>" + _txt[i]+"</span>");
			}
			var _txt_final = _txt_formated.join(_img);
			
			$(this).html(_txt_final);
			
		});
	}
}
$(window).load(function(){
	if($("[TextWithLogo]").length){
		TextWithLogo.init();
	}
});